/**
 * This class is needed to be extended when an action performs Insert, update, delete
 * Look implementation in application.actions.ts
 */
export class Reference {
  public id: string = '';

  public set refId(refId: string) {
    this.id = refId;
  }

  public get refId() {
    return this.id;
  }
}
